module.exports = __webpack_public_path__ + "img/stay.25d0ca72.svg";